import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { ExperimentType, MessageMedium } from 'modules/graphql/types';
import { Nullable } from 'utils/tsHelpers';
import { ExperimentStatusDefinition } from './experimentStatus';
import { EXPERIMENTS_TABLE_COLUMNS } from './tableData';

export type LabelObject = {
  id: number;
  name: string;
};

export type ConversionObject = {
  eventName: string;
  conversions: {
    id: number;
  }[];
};

type ProjectMembership = {
  projectId: number;
};

export type Member = {
  firstName: string;
  lastName: string;
  email: string;
  projectMemberships: ProjectMembership[];
};

export type Pagination = {
  offset: number;
  limit: number;
};

export enum SystemConversionEventDefinition {
  Clicks = 'Clicks',
  Opens = 'Opens',
  Purchases = 'Purchases',
}

export type WinningCriteriaDefinitionInput = {
  systemConversionEvents: Nullable<SystemConversionEventDefinition[]>;
  conversionEventIds: Nullable<number[]>;
};

export enum ExperimentCampaignType {
  ApiTriggered = 'ApiTriggered',
  Blast = 'Blast',
  JourneyTriggered = 'JourneyTriggered',
}

export type ExperimentFilterInfoInput = {
  /** Experiment Filters */
  modifiedBy: Nullable<string[]>;
  experimentTypes: Nullable<ExperimentType[]>;
  winningCriteria: WinningCriteriaDefinitionInput;
  winnerSelected: Nullable<boolean>;
  splitVariationsEvenly: Nullable<boolean>;
  statuses: Nullable<ExperimentStatusDefinition[]>;

  /** Campaign Filters */
  campaignTypes: Nullable<ExperimentCampaignType[]>;
  messageMediums: Nullable<MessageMedium[]>;
  labelIds: Nullable<number[]>;
};

export type ExperimentSortDefinitionInput = {
  by: EXPERIMENTS_TABLE_COLUMNS;
  direction: SORT_DIRECTIONS;
};

export type ExperimentsTableQueryInput = {
  selectedFilters: string[];
  selectedTab: string[];
  pageSize: number;
  page: number;
  sortBy: EXPERIMENTS_TABLE_COLUMNS;
  sortDirection: SORT_DIRECTIONS;
  search: string;
};

export interface ExperimentsTableQuery {
  filterInfo: ExperimentFilterInfoInput;
  pagination: Pagination;
  sort: ExperimentSortDefinitionInput;
  search: string;
}
